import create from '../utils/create';
import { addUnit } from '../utils';
import { BORDER_TOP } from '../utils/constant';
import { ParentMixin } from '../mixins/relation';
export default create({
  render: function render() {
    var _obj;

    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b((_obj = {}, _obj[_vm.BORDER_TOP] = _vm.border && !_vm.gutter, _obj)),
      style: _vm.style
    }, [_vm._t("default")], 2);
  },
  name: 'grid',
  mixins: [ParentMixin('TjGrid')],
  props: {
    square: Boolean,
    gutter: [Number, String],
    iconSize: [Number, String],
    clickable: Boolean,
    columnNum: {
      type: [Number, String],
      default: 4
    },
    center: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      BORDER_TOP: BORDER_TOP
    };
  },
  computed: {
    style: function style() {
      var gutter = this.gutter;

      if (gutter) {
        return {
          paddingLeft: addUnit(gutter)
        };
      }
    }
  }
});